import paymentHelpers from '@/library/payments/paymentHelpers'

function getBaseReturnUrl () {
  const origin = window.ctsautoconf.WEB_SERVER_HOSTNAME || ''
  const capacitorIsEnabled = window.ctsautoconf.CAPACITOR_ENABLED || false
  const isMobileApp = window.ctsautoconf.MOBILE_LS || false
  if (capacitorIsEnabled && isMobileApp) {
    const formatedOrigin = paymentHelpers.removeTrailingSlash(origin)
    return `${formatedOrigin}/${window.location.pathname}`
  }
  return window.location.href
}

export default {
  getBaseReturnUrl
}



// WEBPACK FOOTER //
// ./src/library/payments/igtPayManager.js